(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hb-chatgpt-routine"]) return;
  try {
    
(function(){
  function setup(root){
    if(root.dataset.initialized)return;
    root.dataset.initialized='true';
    const press=root.querySelector('.hbc-press');
    const toggle=root.querySelector('[data-hbc-marquee-toggle]');
    if(toggle)toggle.addEventListener('click',function(){
      const paused=press.classList.toggle('is-paused');
      toggle.setAttribute('aria-pressed',String(paused));
      toggle.textContent=paused?toggle.dataset.resume:toggle.dataset.pause;
    });
    const videos=Array.from(root.querySelectorAll('[data-hbc-video]'));
    videos.forEach(function(video){
      const play=video.closest('figure').querySelector('[data-hbc-video-play]');
      if(play){
        play.hidden=false;
        play.addEventListener('click',function(){video.play().catch(function(){play.hidden=false;});});
        video.addEventListener('pause',function(){play.hidden=false;});
        video.addEventListener('ended',function(){play.hidden=false;});
      }
      video.addEventListener('play',function(){
        if(play)play.hidden=true;
        videos.forEach(function(other){if(other!==video)other.pause();});
      });
    });
    function positionSticky(){
      let offset=0;
      document.querySelectorAll('.hb-mobile-nav,#PBarNextFrame').forEach(function(element){
        const rect=element.getBoundingClientRect();
        const style=getComputedStyle(element);
        if(rect.height>0&&rect.top>window.innerHeight/2&&rect.top<window.innerHeight&&style.visibility!=='hidden'&&style.display!=='none')offset=Math.max(offset,window.innerHeight-rect.top);
      });
      root.style.setProperty('--hbc-bottom-offset',Math.ceil(offset)+'px');
    }
    const observed=new WeakSet();
    const barAttributes=new MutationObserver(positionSticky);
    const resizeObserver=typeof ResizeObserver!=='undefined'?new ResizeObserver(positionSticky):null;
    function observeBars(){
      document.querySelectorAll('.hb-mobile-nav,#PBarNextFrame').forEach(function(element){if(!observed.has(element)){observed.add(element);if(resizeObserver)resizeObserver.observe(element);barAttributes.observe(element,{attributes:true,attributeFilter:['class','style','hidden']});element.addEventListener('transitionend',positionSticky);}});
      positionSticky();
    }
    observeBars();
    window.addEventListener('resize',positionSticky);
    window.addEventListener('load',observeBars);
    if(window.visualViewport){window.visualViewport.addEventListener('resize',positionSticky);window.visualViewport.addEventListener('scroll',positionSticky);}
    barAttributes.observe(document.body,{attributes:true,attributeFilter:['class','style']});
    const barObserver=new MutationObserver(observeBars);
    barObserver.observe(document.body,{childList:true,subtree:true});
    const forms=Array.from(root.querySelectorAll('.hbc-form'));
    const buttons=Array.from(root.querySelectorAll('[data-hbc-submit]'));
    const selector=root.querySelector('[data-hbc-variant]');
    if(!forms.length||!buttons.length)return;
    let pending=false;
    let available=!buttons[0].disabled;
    function updateButtons(message){
      buttons.forEach(function(button){
        button.disabled=pending||!available;
        if(pending)button.setAttribute('aria-busy','true');
        else button.removeAttribute('aria-busy');
        button.firstElementChild.textContent=pending?message:(available?button.dataset.label:button.dataset.soldOut);
      });
    }
    if(selector)selector.addEventListener('change',function(){
      const option=selector.selectedOptions[0];
      root.querySelectorAll('[data-hbc-price]').forEach(function(price){price.textContent=option.dataset.price;});
      root.querySelectorAll('[data-hbc-regular]').forEach(function(price){price.textContent=option.dataset.regular;});
      root.querySelector('[data-hbc-sticky-variant]').value=option.value;
      available=option.dataset.available==='true';
      updateButtons(root.dataset.loading);
    });
    forms.forEach(function(form){
      form.addEventListener('submit',async function(event){
        event.preventDefault();
        if(pending||!available)return;
        const payload=new FormData(form);
        payload.delete('return_to');
        const destination=form.dataset.checkoutPath||root.dataset.returnPath;
        const error=form.querySelector('[data-hbc-error]');
        pending=true;
        updateButtons(form.dataset.checkoutPath?root.dataset.checkoutLoading:root.dataset.loading);
        root.querySelectorAll('[data-hbc-error]').forEach(function(node){node.hidden=true;});
        try{
          const response=await fetch(root.dataset.addUrl,{method:'POST',body:payload,headers:{Accept:'application/json'}});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||root.dataset.error);
          window.location.assign(destination);
        }catch(problem){
          error.textContent=problem.message||root.dataset.error;
          error.hidden=false;
          pending=false;
          updateButtons();
        }
      });
    });
    window.addEventListener('pageshow',function(event){if(event.persisted){pending=false;updateButtons();}});
  }
  document.querySelectorAll('[data-hb-chatgpt]').forEach(setup);
  document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-hb-chatgpt]').forEach(setup);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
